var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.$t('common.nouns.report'),
            "breadCrumbs": _vm.breadCrumbs,
            "chips": _vm.chips,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        }), _c('fleet-manager-tree-dialog', {
          ref: "dialog",
          on: {
            "confirm": _vm.debounceUpdateTable
          }
        }), _vm.fleetId ? _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('paginated-table', {
          key: _vm.updateTableKey,
          attrs: {
            "store": _vm.store,
            "headers": _vm.headers,
            "baseQuery": {
              partnerId: _vm.partnerId,
              fleetId: _vm.fleetId
            },
            "predefinedFilter": _vm.predefinedFilter,
            "showSelect": false,
            "isDownloadAsDisplayed": true
          },
          on: {
            "click:row": _vm.openDetail
          },
          scopedSlots: _vm._u([{
            key: "item.invoiceInboundAggregation.totals",
            fn: function fn(_ref) {
              var item = _ref.item,
                  value = _ref.value;
              return [value ? _c('div', _vm._l(value.split(', '), function (v, index) {
                return _c('div', {
                  key: 'totals' + item.id + index
                }, [_vm._v(" " + _vm._s(v) + " ")]);
              }), 0) : _c('span', {
                staticStyle: {
                  "text-align": "right"
                }
              }, [_vm._v("-")])];
            }
          }, {
            key: "item.invoiceSelfContributionAggregation.totals",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [item.invoiceSelfContributionAggregation && item.invoiceSelfContributionAggregation.totals && item.invoiceSelfContributionAggregation.totals.length > 0 ? _c('div', _vm._l(item.invoiceSelfContributionAggregation.totals, function (total) {
                return _c('div', {
                  key: "invoice_aggregation_self_contribution_".concat(item.id, "_").concat(total.currency)
                }, [_vm._v(" " + _vm._s(_vm.formatCurrency(total.subtotal, total.currency)) + " ")]);
              }), 0) : _c('span', {
                staticStyle: {
                  "text-align": "right"
                }
              }, [_vm._v("-")])];
            }
          }], null, false, 1734389911)
        })], 1)], 1) : _c('v-row', [_c('v-col', [_c('error-card', {
          on: {
            "reload": function reload($event) {
              return _vm.$router.push({
                name: 'FleetAnalyticsView'
              });
            }
          }
        })], 1)], 1), _vm.selectedId && _vm.currentReport ? _c('my-damage-detail-side-card', {
          attrs: {
            "loading": _vm.loading,
            "report": _vm.currentReport
          },
          on: {
            "close": function close($event) {
              _vm.selectedId = null;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }